module.exports = __webpack_public_path__ + "static/img/s117.428ec77a.png";